import { render, staticRenderFns } from "./shareToParent.vue?vue&type=template&id=5d5f61a1&scoped=true&"
import script from "./shareToParent.vue?vue&type=script&lang=js&"
export * from "./shareToParent.vue?vue&type=script&lang=js&"
import style0 from "./shareToParent.vue?vue&type=style&index=0&id=5d5f61a1&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5f61a1",
  null
  
)

export default component.exports